import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '../form/checkbox/checkbox';
import Button from './button';

/**
  A version of the button component which includes a checkbox. It is most commonly rendered
  as a type secondary button, but it also accommodates destructiveMinor and reversed styles.
*/
function CheckboxButton({ checked, children, disabled, indeterminate, ...props }) {
  return (
    <Button
      checkbox={
        <div className="Button__checkbox">
          <Checkbox checked={checked} disabled={disabled} indeterminate={indeterminate} />
        </div>
      }
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
}

CheckboxButton.propTypes = {
  checked: PropTypes.bool,
  /**
    The button's text and/or other contents
  */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  /**
    Checkbox is indeterminate when the checkbox's value reflects a category in which some
    (but not all) items in the category have been selected.
  */
  indeterminate: PropTypes.bool,
};

CheckboxButton.defaultProps = {
  checked: false,
  children: null,
  disabled: false,
  indeterminate: false,
};

export default CheckboxButton;
